<span class="required-marker" i18n="form|Required field marker">(Required)</span>
